import store from '../state/_store.js'
import { renderMeta, showPagination } from '../pagination/_pagination.js'
import { hideLoader } from './_utils.js'

// const compareIDs = (original, compare) => {
//   const secondSet = new Set(compare)

//   // Filter the first array to include only elements not present in the second array's Set
//   const uniqueIds = original.filter((id) => !secondSet.has(id))

//   return uniqueIds
// }

const fetchItemData = async (ids, query) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    console.error('Invalid IDs: must be a non-empty array')
    return null // Ensure we always return something, even on error.
  }

  const url = store.urls('content')
  const maxIdsPerRequest = 150
  const requestData = [] // This will store the final results from all batches.

  // Split IDs into chunks of 'maxIdsPerRequest'
  for (let i = 0; i < ids.length; i += maxIdsPerRequest) {
    const chunk = ids.slice(i, i + maxIdsPerRequest)

    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${store.search.token}`,
        },
      }

      const body = {
        ids: chunk.join(','),
        q: query,
        nonce: store.search.nonce,
      }

      if (store.search.hp) {
        body.hpkey = store.search.hp
      }

      requestOptions.body = JSON.stringify(body)

      const response = await fetch(url, requestOptions)

      if (!response.ok) {
        throw new Error('Network response was not ok.')
      }

      const data = await response.json()

      // if (data?.ids) {
      //   const invalidIDs = compareIDs(chunk, data.ids)
      // }
      if (data?.items) {
        requestData.push(...data.items)
      }
    } catch (error) {
      console.error('There was a problem with your fetch operation:', error)
      // Optionally, continue with the next chunk instead of returning null immediately
      // return null
    }
  }

  return requestData
}

const createItem = (itemData) => {
  let { title, content, url, date } = itemData

  const itemTitle = title
  const itemDescription = content

  const result = document.createElement('a')
  result.className = 'result'
  result.href = url

  date = new Date(date)
  const formatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'long' })

  result.innerHTML = `
    <div class="result__inner">
      <h3 class="result__title">${itemTitle}</h3>
      <span class="result__meta">${formatter.format(date)}</span>
      <p class="result__summary">${itemDescription}</p>
    </div>
  `

  return result
}

const renderResults = async (items, resultsContainer, currentQuery, container) => {
  const { totalItems, perPage, currentPage } = store.search.meta

  const firstItem = (currentPage - 1) * perPage + 1
  let lastItem = currentPage * perPage

  if (lastItem > totalItems) lastItem = totalItems

  const currentItems = items.slice(firstItem - 1, lastItem)
  const itemData = await fetchItemData(
    currentItems.map((item) => item.id),
    currentQuery,
  )

  // Remove existing results
  while (resultsContainer.firstChild) {
    resultsContainer.removeChild(resultsContainer.lastChild)
  }

  // Add new results
  itemData.map((item) => resultsContainer.append(createItem(item)))

  // Generate pagination and attach relevant handlers
  showPagination()
  renderMeta()
  hideLoader(container)
}

export { renderResults }
